module.exports = __webpack_public_path__ + "static/media/promotion_02.aa0c8349.jpg";